/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const BountyEscrowStatus = {
    None: 'None',
    Held: 'Held',
    Released: 'Released',
    Refunded: 'Refunded'
};
export function BountyEscrowStatusFromJSON(json) {
    return BountyEscrowStatusFromJSONTyped(json, false);
}
export function BountyEscrowStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function BountyEscrowStatusToJSON(value) {
    return value;
}
